module.exports = __webpack_public_path__ + "static/media/tvshows-edutainment-icon.a1d2bcf0.svg";